{
  "fastTrack": {
    "adminResolving": "處理中"
  }
}
